/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProgramQuery } from '../../models/get-program-query';
import { GetProgramQueryResult } from '../../models/get-program-query-result';

export interface ApiProgramGetProgramPost$Plain$Params {
      body?: GetProgramQuery
}

export function apiProgramGetProgramPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProgramGetProgramPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProgramGetProgramPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProgramQueryResult>;
    })
  );
}

apiProgramGetProgramPost$Plain.PATH = '/api/Program/GetProgram';
